import {MyopMessages} from "../../common/MyopMessages";
import {BindClickMessage, ClickReplayMessage, MyopBindMessage} from "../../messages";
import {ShadowRootRef} from "../shadowRootRef";
import {BaseWebComponentMessageHandler, MessageToHost} from "./BaseWebComponentMessageHandler";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class BindOnClickHandler extends BaseWebComponentMessageHandler<BindClickMessage> {

    messageType = MyopMessages.BindClickMessage;

    innerExecutor = (event: BindClickMessage, shadowRootRef: ShadowRootRef, messageToHost: MessageToHost) => {
        const items = getElementsByRef(event.ref, shadowRootRef.shadowRoot)
        const cleanupTasks: any[] = [];

        items.forEach(item => {
            const handler = () => {
                messageToHost(new ClickReplayMessage(event.handlerUniqueId));
            };

            item.addEventListener('click', handler);
            cleanupTasks.push(() => {
                item.removeEventListener('click', handler);
            })
        })

        return () => {
            cleanupTasks.forEach(task => task());
        }
    }
}
